export default __webpack_public_path__ + "static/media/LVZ WEB ICONS - MEMBER ACTIVITIES.f1f3b103.svg";